import { render, staticRenderFns } from "./PayrollEmployeesKjarni.vue?vue&type=template&id=453e9d19&"
import script from "./PayrollEmployeesKjarni.vue?vue&type=script&lang=ts&"
export * from "./PayrollEmployeesKjarni.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports